import React from "react";
import { useTranslation } from "react-i18next";

const WhatsG80 = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-primary-800 mb-8">
        {t("whats_g80.title")}
      </h1>

      <div className="prose prose-lg max-w-none space-y-6">
        <p className="mb-8">{t("whats_g80.intro")}</p>

        <p className="mb-8">{t("whats_g80.reddit_spark")}</p>

        <blockquote className="bg-gray-50 border-l-4 border-accent-500 p-4 my-8 italic dark:bg-gray-900">
          {t("whats_g80.reddit_comment.part1")}
          <br />
          <br />
          {t("whats_g80.reddit_comment.part2")}
          <br />
          <br />
          {t("whats_g80.reddit_comment.part3")}
          <br />
          <br />
          {t("whats_g80.reddit_comment.part4")}
          <br />
          <br />
          <a
            href="https://www.reddit.com/r/malaysia/comments/1igmgxu/comment/marzg25/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-accent-600 hover:text-accent-700 not-italic text-sm"
          >
            - {t("whats_g80.reddit_comment.source")}
          </a>
        </blockquote>

        <p className="mb-8">{t("whats_g80.inspiration")}</p>

        <div className="my-12 bg-gray-50 rounded-lg overflow-hidden">
          <img
            src="https://platform.theverge.com/wp-content/uploads/sites/2/chorus/uploads/chorus_asset/file/8518019/not_hot_dog_app.png"
            alt={t("whats_g80.silicon_valley.caption")}
            className="w-full h-auto"
          />
          <p className="text-sm text-gray-600 italic p-4 text-center dark:text-gray-400 dark:bg-gray-900">
            {t("whats_g80.silicon_valley.caption")}
          </p>
        </div>

        <p className="mb-8">{t("whats_g80.development")}</p>

        <p className="mb-6">{t("whats_g80.goals.title")}</p>
        <ul className="list-disc pl-6 space-y-4 mb-8">
          {t("whats_g80.goals.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        <p className="mt-8">{t("whats_g80.join_us")}</p>
      </div>
    </div>
  );
};

export default WhatsG80;
